import { render, staticRenderFns } from "./supplier-invoice.vue?vue&type=template&id=dc671520"
import script from "./supplier-invoice.vue?vue&type=script&lang=js"
export * from "./supplier-invoice.vue?vue&type=script&lang=js"
import style0 from "./supplier-invoice.vue?vue&type=style&index=0&id=dc671520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports